import { Grid, Card, CardHeader, CardContent, Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslate } from 'react-admin';
import SendMessageAttachmentIcon from '@/assets/icons/send-message-attachment-icon.svg?react';
import { styled } from '@mui/material/styles';
import { Palette } from '@/themes/themeOverrides/Palette';
import LanguageSwitcher from '@/components/global/menu/LanguageSwitcher.jsx';

const StyledCard = styled(Card)(() => ({
    width: 400,
    borderRadius: '32px',
    padding: '48px 40px 16px',
    boxShadow: Palette.boxShadow.elevation3,
}));

const StyledCardHeader = styled(CardHeader)(() => ({
    padding: '0px',
    marginBottom: '14px',
    '& .MuiTypography-root': {
        fontSize: '18px',
    },
}));

const StyledCardContent = styled(CardContent)(() => ({
    padding: 0,
    '& .MuiGrid-root.MuiGrid-item': {
        width: '100%',
    },
    '& .go-to-login-button': {
        padding: '14px 16px',
        marginTop: '26px',
        '&:hover': {
            color: 'inherit',
        },
    },
}));

const ResetPasswordInfoPage = () => {
    const translate = useTranslate();

    return (
        <>
            <Box sx={{ position: 'fixed', top: 32, right: 32 }}>
                <LanguageSwitcher />
            </Box>
            <Box height={'98vh'} display='flex' alignItems='center' justifyContent='center' gap={4} p={2}>
                <StyledCard>
                    <Box sx={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
                        <SendMessageAttachmentIcon />
                    </Box>
                    <StyledCardHeader title={translate('auth.checkEmailTitle')} />
                    <StyledCardContent>
                        <Grid container>
                            <Grid item sm={12}>
                                <Button
                                    className='go-to-login-button'
                                    to='/login'
                                    component={Link}
                                    color='primary'
                                    size='small'
                                    type='submit'
                                    variant='contained'
                                    fullWidth
                                >
                                    {translate('auth.backToLogin')}
                                </Button>
                            </Grid>
                        </Grid>
                    </StyledCardContent>
                </StyledCard>
            </Box>
        </>
    );
};

export default ResetPasswordInfoPage;
